import React from "react";
import {useEffect, useState} from "react";
import {changePageSizeState} from "../../../Slices/PageSlice";
import PageSizeState from "../../../Constants/Base/PageSizeState";
import {useDispatch} from "react-redux";
import TablePage from "../../../Components/DataGrid/TablePage";
import strings from "../../../localization";
import {changeBreadcrumbs} from "../../../Slices/BreadcrumbsSlice";
import Modules from "../../../Constants/Base/Modules";
import TablePageContext, {
    FilterDefaults,
    TableDataDefaults,
    TablePageOptionDefaults
} from "../../../Context/TablePageContext";
import PageState from "../../../Constants/Base/PageState";
import ReferenceType from "../../../Constants/DocumentManagement/ReferenceType";
import AppPermissions from "../../../Constants/Permissions/Permissions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { deleteDealType, getDealTypes } from "../../../Services/CRM/DealTypeService";
import AddDealType from "./AddDealType";
import EditDealType from "./EditDealType";
import Tag from "../../../Components/Forms/Pages/Document/Tag/Tag";

const tableDescription = [
    {field: 'name', headerName: strings.pages.crm.dealType.dealTypeList.name, width: 200}
];

const filters = []

const DealTypeList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [updatedFilter, setUpdatedFilter] = useState(!Boolean(searchParams.toString()));
    const [columns, setColumns] = useState([]);
    const [pageState, setPageState] = useState(PageState.View);
    const [filter, setFilter] = useState(FilterDefaults);
    const [tableData, setTableData] = useState(TableDataDefaults);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedItems, setSelectedItems] = useState(null);
    const [tablePageOptions, setTablePageOptions] = useState(TablePageOptionDefaults);
    const referenceType = ReferenceType.DEAL_TYPE;
    const permissionGroup = AppPermissions.DEAL_TYPE.GROUP;

    const value = {
        tablePageOptions, setTablePageOptions,
        navigate,
        selectionModel, setSelectionModel,
        selectedItems, setSelectedItems,
        filter, setFilter, pageState, setPageState, showDeleteDialog, setShowDeleteDialog,
        updatedFilter, setUpdatedFilter
    }

    useEffect(() => {
        setColumns([...tableDescription]);
        dispatch(changePageSizeState(PageSizeState.SHORT));
        dispatch(changeBreadcrumbs({
            title: strings.pages.crm.dealType.dealTypeList.pageTitle,
            hierarchy:[
                {label: strings.navigation.managmentTag},
                {label: Modules.CRM},
                {label: strings.pages.crm.settings.settings},
                {label: strings.pages.crm.dealType.dealTypeList.pageTitle},
            ],        
        }));

        return () => {
            setTableData({})
        }

    }, [])

    useEffect(() => {
        if(!updatedFilter){
            return;
        }

        fetch()
    }, [filter, updatedFilter])

    const onCancel = () => {
        setPageState(PageState.View);
    }

    const onFinish = () => {
        fetch();
        setPageState(PageState.View);
    }

    const fetch = () => {
        setTableData({
            ...tableData,
            loading: true
        });

        getDealTypes({
            ...filter
        }).then(response => {

            if (!response || !response.ok) {
                return;
            }
            
            setTableData({
                loading: false,
                data: response.data.result,
                total: response.data.total,
            });
        })
    }

    return <TablePageContext.Provider value={value}>
        <TablePage onFinish={() => onFinish()} deleteItem={deleteDealType} tableDescription={columns}
                   tableData={tableData} 
                   filter={filter} filters={filters}
                   permissionGroup={permissionGroup}
                   referenceType={referenceType}
                   tagPage={<Tag referenceType={ referenceType } data={ selectedItems } /> }
                   editPage={<EditDealType data={ selectedItems }
                                          onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   addPage={<AddDealType onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   hideBreadcrumbs
                   addButtonText={strings.components.tablePage.addButton.dealType}/>
    </TablePageContext.Provider>;
}

export default DealTypeList;
